// 결제 타입 텍스트 반환 함수
export const getSubscriptionTypeText = (item: any, isWrapsodyEco: boolean) => {
  const { billType, priceType } = item;
  if (priceType === "cancel") {
    return "siteManagement.paymentHistory.paymentManagement.cancelSubscription";
  }

  const types: Record<string, string> = {
    trial: "subscriptionType.type.free_2",
    promotion: "subscriptionType.type.premium",
    plus: isWrapsodyEco ? "subscriptionType.type.plus" : "Enterprise",
    basic: isWrapsodyEco ? "subscriptionType.type.basic" : "Standard",
    basicPlus: "Standard Plus",
    plusPlus: "Enterprise Plus",
  };
  return types[priceType] || "";
};

// 날짜 포맷팅 함수
export const formatDate = (dateStr: string) => {
  return `${dateStr?.slice(0, 4)}-${dateStr?.slice(4, 6)}-${dateStr?.slice(
    6,
    8
  )}`;
};

// 결제 주기 텍스트 반환 함수
export const getPayTermText = (term: string) => {
  if (term === "month") {
    // 매달 결제
    return "siteManagement.paymentHistory.popUp.changePaymentCycle.payType_month";
  }
  if (term === "year") {
    // 연 1회 결제
    return "siteManagement.paymentHistory.popUp.changePaymentCycle.payType_annual";
  }
  return "";
};
